export default __webpack_public_path__ + "static/media/vodor.4581c0bb.pdf";